/* ---------------------------------------------------------------
   index.js  –  Page transitions (with BARS transition)
---------------------------------------------------------------- */

/* 0.  Overlay – inject once, as high as possible */
if (!document.querySelector('.transition')) {
    const overlay = document.createElement('div');
    overlay.className = 'transition';
    overlay.innerHTML = '<div></div>'.repeat(4); // 4 horizontal bars
    document.body.appendChild(overlay);
}

/* 1. Imports */
import gsap from 'gsap';
import svg4everybody from 'svg4everybody';

// Import lottie player at the top level to fix dynamic import issue
import '@lottiefiles/lottie-player';

/* Components / blocks
   ------------------------------------------------------------- */
import MobileMenu from './components/mobile-menu';
import Menu from './components/menu';
import Search from './components/search';
import latestNews from './blocks/latestNews';
import filterDropdowns from './components/filterDropdowns';
import archivePosts from './blocks/archivePosts';
import gallery from './blocks/gallery';
import textItems from './blocks/textItems';
import latestPublications from './blocks/latestPublications';
import subscribe from './blocks/subscribe';
import publicationsArchive from './blocks/publicationsArchive';
import teamCards from './components/teamCards';
import teamArchive from './blocks/teamArchive';
import autoSearch from './components/autoSearch';
import Hero from './components/hero';
import downloadPopup from './components/downloadPopup';
import ourMission from './blocks/ourMission';
import logoDownload from './blocks/logoDownload';
import itemsText from './blocks/itemsText';
import faq from './blocks/faq';
import textAndItems from './blocks/textAndItems';
import chatFaq from './blocks/chatFaq';
import quickLinks from './components/quickLinks';
import latestJob from './blocks/latestJob';
import videoModal from './components/videoModal';
import recommendationPopup from './components/recommendationPopup';
import commision from './blocks/commision';
import otherDocuments from './blocks/otherDocuments';
import lastReviews from './blocks/lastReviews';
import map from './blocks/map';

/* 1.  Build one idempotent bootstrap
      ----------------------------------------------------------- */
export function initSite(ctx = document) {
    svg4everybody();

    /* Pass ctx ↓ if modules query within a scope, otherwise omit */
    MobileMenu(ctx);
    Menu(ctx);
    Search(ctx);
    latestNews(ctx);
    filterDropdowns(ctx);
    archivePosts(ctx);
    gallery(ctx);
    textItems(ctx);
    latestPublications(ctx);
    // subscribe(ctx);                    // uncomment when live
    publicationsArchive(ctx);
    teamCards(ctx);
    teamArchive(ctx);
    autoSearch(ctx);
    Hero(ctx);
    downloadPopup(ctx);
    ourMission(ctx);
    logoDownload(ctx);
    itemsText(ctx);
    faq(ctx);
    textAndItems(ctx);
    chatFaq(ctx);
    quickLinks(ctx);
    latestJob(ctx);
    videoModal(ctx);
    recommendationPopup(ctx);
    commision(ctx);
    otherDocuments(ctx);
    lastReviews(ctx);
    map(ctx);
}

/* 2.  Fire once on vanilla load
      ----------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {

    initSite();


    // Start with columns closed
    gsap.set('.transition div', {
        scaleX: 1,
        transformOrigin: 'left top'
    });

    // Open columns animation on page load
    const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });

    // Animate columns opening
    tl.to('.transition div', {
        scaleX: 0,
        transformOrigin: 'right top',
        duration: 1,
        ease: 'power4.out',
        stagger: -0.1,
        delay: 0.5
    }, 0);

    // Fade in content
    tl.to('body > *:not(.transition)', {
        autoAlpha: 1,
        duration: 0.35
    }, 0.25);

});
